/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceFloorplanHistoryDto } from '../../models/device-floorplan-history-dto';

export interface DeviceControllerFindFloorplanHistory$Params {
  id: string;
  clientWorkspaceId: string;
  take: string;
}

export function deviceControllerFindFloorplanHistory(http: HttpClient, rootUrl: string, params: DeviceControllerFindFloorplanHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DeviceFloorplanHistoryDto>>> {
  const rb = new RequestBuilder(rootUrl, deviceControllerFindFloorplanHistory.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.query('take', params.take, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DeviceFloorplanHistoryDto>>;
    })
  );
}

deviceControllerFindFloorplanHistory.PATH = '/api/device/{id}/floorplan-history';
